import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import DunningProfiles from "./dunningProfiles";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import {
  addNewDunningEventAction,
  addNewDunningEventActionSuccess,
  createDunningLockType,
  createDunningLockTypeSuccess,
  deleteDunningEventAction,
  deleteDunningEventActionSuccess,
  deleteDunningLockType,
  deleteDunningLockTypeSuccess,
  getDunningActionList,
  getDunningLockTypeList,
  updateDunningEventAction,
  updateDunningEventActionSuccess,
  updateDunningLockType,
  updateDunningLockTypeSuccess,
} from "../../../../store/dunning/action";
import { toast } from "react-toastify";
export default function DebtChasingSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const { dunningActionListAPI, dunningLockTypeListAPI } = useSelector(
    (state) => ({
      dunningActionListAPI:
        state.Dunning.dunningActionList?.dunningeventaction_list,
      dunningLockTypeListAPI:
        state.Dunning.dunningLockTypeList?.dunninglocktype_list,
    })
  );

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addNewDunningEventAction([createStatus]));
    }
    if (activeTab === "2") {
      //   Lock Type create
      dispatch(createDunningLockType([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = dunningActionListAPI?.sort((a, b) => b.Id - a.Id);
    }
    if (activeTab === "2") {
      data = dunningLockTypeListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [dunningActionListAPI, activeTab, dunningLockTypeListAPI]);

  useEffect(() => {
    dispatch(getDunningActionList());
    dispatch(getDunningLockTypeList());
  }, []);

  const Tabs = [
    {
      id: "1",
      name: "Action Types",
    },
    {
      id: "2",
      name: "Lock Types",
    },
    {
      id: "3",
      name: "Dunning Profiles & Steps",
    },
  ];
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteDunningEventAction([deleteStatus]));
    }
    if (activeTab === "2") {
      // Lock Type delete
      dispatch(deleteDunningLockType([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateDunningEventAction([updateNewStatus]));
      }
      if (activeTab === "2") {
        //  Lock Type update
        dispatch(updateDunningLockType([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  //Effects
  const {
    addDunningEventActionSuccessAPI,
    updateDunningEventActionSuccessAPI,
    deleteDunningEventActionSuccessAPI,
    createDunningLockTypeResponseAPI,
    updateDunningLockTypeResponseAPI,
    deleteDunningLockTypeResponseAPI,
  } = useSelector((state) => ({
    addDunningEventActionSuccessAPI: state.Dunning.addDunningEventActionSuccess,
    updateDunningEventActionSuccessAPI:
      state.Dunning.updateDunningEventActionSuccess,
    deleteDunningEventActionSuccessAPI:
      state.Dunning.deleteDunningEventActionSuccess,
    createDunningLockTypeResponseAPI:
      state.Dunning.createDunningLockTypeResponse,
    updateDunningLockTypeResponseAPI:
      state.Dunning.updateDunningLockTypeResponse,
    deleteDunningLockTypeResponseAPI:
      state.Dunning.deleteDunningLockTypeResponse,
  }));

  // Add new Dunning Event success
  useEffect(() => {
    if (isEmpty(addDunningEventActionSuccessAPI)) return;
    if (addDunningEventActionSuccessAPI.status === 200) {
      toast.success(addDunningEventActionSuccessAPI.message);
      dispatch(getDunningActionList());
    } else {
      toast.error(addDunningEventActionSuccessAPI.message);
    }
    dispatch(addNewDunningEventActionSuccess([]));
  }, [addDunningEventActionSuccessAPI]);

  // Update Dunning Event success
  useEffect(() => {
    if (isEmpty(updateDunningEventActionSuccessAPI)) return;
    if (updateDunningEventActionSuccessAPI.status === 200) {
      toast.success(updateDunningEventActionSuccessAPI.message);
      dispatch(getDunningActionList());
    } else {
      toast.error(updateDunningEventActionSuccessAPI.message);
    }
    dispatch(updateDunningEventActionSuccess([]));
  }, [updateDunningEventActionSuccessAPI]);

  // Delete Dunning Event success
  useEffect(() => {
    if (isEmpty(deleteDunningEventActionSuccessAPI)) return;
    if (deleteDunningEventActionSuccessAPI.status === 200) {
      toast.success(deleteDunningEventActionSuccessAPI.message);
      dispatch(getDunningActionList());
      setDeleteModal(false);
    } else {
      toast.error(deleteDunningEventActionSuccessAPI.message);
    }
    dispatch(deleteDunningEventActionSuccess([]));
  }, [deleteDunningEventActionSuccessAPI]);

  //create Dunning Lock Type success
  useEffect(() => {
    if (isEmpty(createDunningLockTypeResponseAPI)) return;
    if (createDunningLockTypeResponseAPI.status === 200) {
      toast.success(createDunningLockTypeResponseAPI.message);
      dispatch(getDunningLockTypeList());
    } else {
      toast.error(createDunningLockTypeResponseAPI.message);
    }
    dispatch(createDunningLockTypeSuccess([]));
  }, [createDunningLockTypeResponseAPI]);

  // Update Dunning Lock Type success
  useEffect(() => {
    if (isEmpty(updateDunningLockTypeResponseAPI)) return;
    if (updateDunningLockTypeResponseAPI.status === 200) {
      toast.success(updateDunningLockTypeResponseAPI.message);
      dispatch(getDunningLockTypeList());
    } else {
      toast.error(updateDunningLockTypeResponseAPI.message);
    }
    dispatch(updateDunningLockTypeSuccess([]));
  }, [updateDunningLockTypeResponseAPI]);

  // Delete Dunning Lock Type success
  useEffect(() => {
    if (isEmpty(deleteDunningLockTypeResponseAPI)) return;
    if (deleteDunningLockTypeResponseAPI.status === 200) {
      toast.success(deleteDunningLockTypeResponseAPI.message);
      dispatch(getDunningLockTypeList());
      setDeleteModal(false);
    } else {
      toast.error(deleteDunningLockTypeResponseAPI.message);
    }
    dispatch(deleteDunningLockTypeSuccess([]));
  }, [deleteDunningLockTypeResponseAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Debt Chasing Settings"
        description="Action types, lock types and dunning profiles used when chasing overdue invoices."
        tabs={Tabs.map((item) => ({ value: item.id, label: item.name }))}
        value={activeTab}
        onChange={setActiveTab}
      >
        {activeTab === "3" ? (
          <DunningProfiles />
        ) : (
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
          />
        )}
      </SettingsPanel>
    </>
  );
}
